export default [
  {
    path: "/users",
    name: "users",
    component: () => import("../views/masterdata/users/UsersView.vue"),
  },
];
